/**
 * The landing page's fixed copy: the "How it works" steps and the "Built for
 * stories" features. Shared by the live page (LandingPage) and its static,
 * crawler-readable copy that the build writes into index.html
 * (prerender/staticPages.tsx), so the two never drift apart.
 */

export const LANDING_STEPS = [
  { titleKey: "landing.step1Title", textKey: "landing.step1Text" },
  { titleKey: "landing.step2Title", textKey: "landing.step2Text" },
  { titleKey: "landing.step3Title", textKey: "landing.step3Text" }
] as const;

export const LANDING_FEATURES = [
  {
    // Branching path: choices that matter.
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 3v6a4 4 0 0 0 4 4h8" />
        <path d="M6 13v8" />
        <path d="m15 9 4 4-4 4" />
      </svg>
    ),
    titleKey: "landing.feat1Title",
    textKey: "landing.feat1Text"
  },
  {
    // A framed picture: illustrated scenes.
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <circle cx="9" cy="10" r="2" />
        <path d="m21 16-5-5-9 9" />
      </svg>
    ),
    titleKey: "landing.feat2Title",
    textKey: "landing.feat2Text"
  },
  {
    // A flag at the finish: every route reaches an ending.
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 21V4" />
        <path d="M4 4h13l-2.5 4L17 12H4" />
      </svg>
    ),
    titleKey: "landing.feat3Title",
    textKey: "landing.feat3Text"
  },
  {
    // A phone: read anywhere, in the browser.
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="6" y="2" width="12" height="20" rx="2" />
        <path d="M11 18h2" />
      </svg>
    ),
    titleKey: "landing.feat4Title",
    textKey: "landing.feat4Text"
  }
] as const;
